(() => {
  if (window.annaritaVariantGestureGuard) return;
  window.annaritaVariantGestureGuard = true;

  let gesture = null;
  let suppressedFieldset = null;
  let suppressUntil = 0;

  document.addEventListener('pointerdown', (event) => {
    if (event.button !== 0) return;
    const label = event.target.closest?.('.ag-variant-choice');
    if (!label) return;
    gesture = {
      pointerId: event.pointerId,
      x: event.clientX,
      y: event.clientY,
      fieldset: label.closest('fieldset'),
      moved: false,
    };
  }, { capture: true, passive: true });

  document.addEventListener('pointermove', (event) => {
    if (!gesture || event.pointerId !== gesture.pointerId) return;
    if (Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) > 8) {
      gesture.moved = true;
    }
  }, { capture: true, passive: true });

  const finishGesture = (event) => {
    if (!gesture || event.pointerId !== gesture.pointerId) return;
    if (gesture.moved) {
      suppressedFieldset = gesture.fieldset;
      suppressUntil = Date.now() + 400;
    }
    gesture = null;
  };

  document.addEventListener('pointerup', finishGesture, { capture: true, passive: true });
  document.addEventListener('pointercancel', finishGesture, { capture: true, passive: true });
  document.addEventListener('click', (event) => {
    if (event.detail === 0 || Date.now() > suppressUntil) return;
    const label = event.target.closest?.('.ag-variant-choice');
    if (!label || label.closest('fieldset') !== suppressedFieldset) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('dragstart', (event) => {
    if (event.target.closest?.('.ag-variant-choice__media')) event.preventDefault();
  }, true);
})();
